export const SCREENING_BROWNOUT_CODE = 'SCREENING_BROWNOUT';

export function getScreeningBrownoutMessage(response) {
  return response?.data?.httpStatus === 424 && response?.data?.error?.code === SCREENING_BROWNOUT_CODE
    ? response?.data?.error?.message
    : null;
}

export function isBrownoutOn(response) {
  return (
    response?.data?.httpStatus === 424 &&
    // Do not block rest of application if just a screening brownout.
    !getScreeningBrownoutMessage(response)
  );
}
